import axios from "./axios";

class PackageRepository {
  get() {
    return axios.get(`/packages`).then((response) => {
      return response.data;
    });
  }

  create(item) {
    return axios.post(`/packages`, item).then((response) => {
      return response.data;
    });
  }

  update(item) {
    return axios.put(`/packages/${item.id}`, item).then((response) => {
      return response.data;
    });
  }

  save(item) {
    if (!item.id) return this.create(item);
    else return this.update(item);
  }
}

export default new PackageRepository();



// WEBPACK FOOTER //
// ./src/data/package.repository.js